import noticeError from "./notice-error";
import { requestHelper } from "./request-helper";
import sdkProvider from "./sdk-provider";

export const createVerificationRequest = async (
  payload,
  displayVerificationErrorPage,
  sheerIdLocale,
  successRedirectPath
) => {
  try {
    const identity = await sdkProvider("identity");
    const authHeader = await identity.getAuthHeader();
    const customerId = await identity.customer.customerId();
    const successRedirectUrl = `https://${window.location.host}${successRedirectPath}`;
    const response = await requestHelper.post({
      url: `/api/marketing/student/v1/customers/${customerId}/verificationRequests?locale=${sheerIdLocale}&successRedirectUrl=${successRedirectUrl}`,
      headers: {
        Authorization: authHeader,
        "Content-Type": "application/json",
      },
      body: payload,
    });
    return response?.data;
  } catch (error) {
    if (
      error?.response?.data?.[0].errorMessage ===
      "New verification not allowed at the moment."
    ) {
      displayVerificationErrorPage();
    }
    noticeError(error);
  }
};
